import React from "react";
import { Stack } from "@mui/material";
import DiamondProfile from "../widgets/DiamondProfile";
import DiamondGallery from "../widgets/DiamondGallery";
import DiamondColorAnalysis from "../widgets/DiamondColorAnalysis";
import AnalysisActions from "../widgets/AnalysisActions";
import SectionPaper from "../widgets/SectionPaper";
import { isAnalyzed, isPattern } from "../../backend/calibration";
import ImageAnalysis from "../widgets/ImageAnalysis";

type DiamondAnalysisViewProps = {
  diamond: any;
  image?: { id: string; calibration?: string };
};

// The stone's analysis screen: the diamond header, then one section paper divided by section titles
// — the stone's pictures (the one calibrated below picked out) with the page's buttons on one line
// under them, the analysis of its color, and the calibration of that picture. Shared by the from-diamond and from-image routes, which differ only
// in how they pick the diamond and the image.
const DiamondAnalysisView = ({ diamond, image }: DiamondAnalysisViewProps) => {
  // A stone's color is read from its original and its pattern: with neither, there is nothing
  // to analyze and no analysis to show.
  const hasOriginalOrPattern = (diamond?.images ?? []).some(
    (picture: any) =>
      isAnalyzed(picture.calibration) || isPattern(picture.calibration),
  );

  return (
    <Stack spacing={1} useFlexGap>
      {diamond && <DiamondProfile data={diamond} page="image" />}
      {diamond && (
        <SectionPaper>
          <DiamondGallery data={diamond} selectedImageID={image?.id} />
          <AnalysisActions
            diamondID={diamond.id}
            imageID={image?.id}
            canAnalyze={hasOriginalOrPattern}
          />
          {hasOriginalOrPattern && (
            <DiamondColorAnalysis diamondID={diamond.id} />
          )}
          {image && (
            <ImageAnalysis imageID={image.id} calibration={image.calibration} />
          )}
        </SectionPaper>
      )}
    </Stack>
  );
};

export default DiamondAnalysisView;
